import BlAvatarAv from './BlAvatarAv.vue'

BlAvatarAv.install = function(Vue) {
  Vue.component(BlAvatarAv.name, BlAvatarAv)
}

export default BlAvatarAv
